import {useQuery, useQueryClient} from "@tanstack/react-query"
import {useCallback} from "react"
import {courseCategoryService} from "services"

const queryCacheKey = "all-course-categories"
const INITIAL_DATA = []

export const useAllCourseCategories = () => {
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey],
        async () => {
            const {data: courseCategories} = await courseCategoryService.getAllCourseCategories()
            return courseCategories
        },
        {
            refetchOnMount: false
        }
    )

    return {
        courseCategories: query.data ?? INITIAL_DATA,
        invalidateCourseCategoriesCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient]),
        isLoading: query.isLoading
    }
}
